export class DateOnly {
  month = 0;
  day = 0;

  /**
   * Creates a new object representing a date with no time.
   *
   * @param year Integer value representing the year.
   * @param month Integer value representing the month, beginning with 0 for January to 11 for December. If a value less than 0 or greater than 11 is passed in, then those months will be substracted/added to the date.
   * @param day Integer value representing the day of the month. If a value less than 1 or greater than max days of month is passed in, then those days will be substracted/added to the date.
   */
  constructor(
    public year: number,
    month: number,
    day: number,
  ) {
    const date = new Date(year, month, day);
    this.month = date.getMonth();
    this.day = date.getDate();
  }

  /**
   * Returns a Date object and time set to 00:00:00.
   */
  toDate() {
    return new Date(this.year, this.month, this.day);
  }

  /**
   * Returns a DateOnly object given a Date object.
   *
   * @param date Date object.
   */
  static fromDate(date: Date) {
    return new DateOnly(date.getFullYear(), date.getMonth(), date.getDate());
  }
}
